import React from 'react';
import { Link } from 'react-router-dom';

function PersonalInjury() {
  return (
    <div className="page-content">
      <div className="page-header">
        <h1>Personal Injury Law</h1>
        <p>Fighting for the compensation you deserve after an accident</p>
      </div>

      <section className="content-section">
        <div className="text-content">
          <p>If you've been injured due to someone else's negligence, you have the right to compensation. At Sol LLP, our personal injury lawyers have recovered millions of dollars for accident victims throughout British Columbia. We handle all aspects of your claim so you can focus on recovery, and we don't get paid unless you win.</p>

          <h3>Motor Vehicle Accidents</h3>
          <p>Car, truck, and motorcycle accidents are the leading cause of personal injury claims in BC. We have extensive experience with ICBC claims and litigation, including:</p>
          <ul>
            <li>Car and truck accidents</li>
            <li>Motorcycle collisions</li>
            <li>Pedestrian and cyclist accidents</li>
            <li>Hit and run incidents</li>
            <li>Uninsured/underinsured motorist claims</li>
            <li>Catastrophic injury cases</li>
          </ul>

          <h3>ICBC Claims</h3>
          <p>Navigating ICBC's claims process can be frustrating and complex. Our lawyers know how to maximize your settlement and aren't afraid to take your case to court when ICBC's offer is unfair. We handle:</p>
          <ul>
            <li>Part 7 benefit claims (no-fault benefits)</li>
            <li>Enhanced care coverage</li>
            <li>Tort claims for pain and suffering</li>
            <li>Wage loss claims</li>
            <li>Cost of future care assessments</li>
            <li>Diminished earning capacity claims</li>
          </ul>

          <h3>Slip and Fall Accidents</h3>
          <p>Property owners have a duty to maintain safe premises. If you've been injured in a slip and fall, trip and fall, or other premises liability accident, we can help you hold negligent property owners accountable.</p>

          <h3>Workplace Injuries</h3>
          <p>While WorkSafeBC provides benefits for most workplace injuries, you may be entitled to additional compensation through a personal injury claim if a third party was responsible for your injury.</p>

          <h3>Catastrophic Injuries</h3>
          <p>Severe injuries require experienced legal representation to ensure you receive full compensation for lifelong impacts. We handle cases involving:</p>
          <ul>
            <li>Traumatic brain injuries (TBI)</li>
            <li>Spinal cord injuries and paralysis</li>
            <li>Amputation injuries</li>
            <li>Severe burns</li>
            <li>Multiple fractures</li>
            <li>Permanent disability</li>
          </ul>

          <h3>Wrongful Death Claims</h3>
          <p>When negligence results in a fatal accident, we help families pursue wrongful death claims under BC's Family Compensation Act. We handle these sensitive matters with compassion while aggressively pursuing justice.</p>

          <h3>What We Recover For You</h3>
          <p>Our personal injury lawyers fight to maximize compensation for all your losses:</p>
          <ul>
            <li>Medical expenses and rehabilitation costs</li>
            <li>Lost wages and future income loss</li>
            <li>Pain and suffering</li>
            <li>Cost of future care</li>
            <li>Loss of housekeeping capacity</li>
            <li>Special damages and out-of-pocket expenses</li>
          </ul>

          <h3>No Recovery, No Fee</h3>
          <p>We work on a contingency fee basis for personal injury cases. This means you pay nothing unless we win your case. We advance all costs and expenses, removing financial barriers to quality legal representation.</p>

          <h3>Our Process</h3>
          <p>1. <strong>Free Consultation:</strong> We review your case and explain your rights at no cost<br />
          2. <strong>Investigation:</strong> We gather evidence, medical records, and expert opinions<br />
          3. <strong>Negotiation:</strong> We demand fair compensation from insurers and at-fault parties<br />
          4. <strong>Litigation:</strong> If settlement fails, we're prepared to take your case to trial<br />
          5. <strong>Recovery:</strong> We secure maximum compensation for your injuries</p>

          <div style={{ marginTop: '40px', padding: '30px', background: '#fff3cd', borderRadius: '8px' }}>
            <h3>Time Limits Apply</h3>
            <p>BC law imposes strict time limits (usually 2 years) for filing personal injury claims. Don't delay—contact us today to protect your rights.</p>
          </div>

          <div style={{ marginTop: '40px', padding: '30px', background: '#f7fafc', borderRadius: '8px', textAlign: 'center' }}>
            <h3>Injured in an Accident?</h3>
            <p>Get the legal representation you need to secure fair compensation. Your consultation is free, and you pay nothing unless we win.</p>
            <Link to="/contact" className="cta-button" style={{ marginTop: '20px' }}>Get Your Free Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PersonalInjury;

